import { ArrowUUpLeftIcon } from '@phosphor-icons/react'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'

import { formatMoney } from '../../../helpers/helpers'

const TicketPrice = ({ id, price, refundedAmount }) => {
  const { t } = useTranslation(['attendees'])
  const formattedPrice = formatMoney(price || 0)
  const formattedRefundedAmount = refundedAmount ? formatMoney(refundedAmount) : ''

  return (
    <div className="attendee_ticket-price-cell">
      <span data-tip data-for={`${id}-event-refunded-ticket-price`}>
        {formattedPrice}
      </span>
      {formattedRefundedAmount && (
        <div className="icon-container" data-tip data-for={`${id}-event-refunded-ticket-price`}>
          <ArrowUUpLeftIcon size={10} />
        </div>
      )}
      {formattedRefundedAmount && (
        <ReactTooltip id={`${id}-event-refunded-ticket-price`} effect="solid">
          {t('attendees:refundedAmount', { amount: formattedRefundedAmount })}
        </ReactTooltip>
      )}
    </div>
  )
}

export default TicketPrice
